export default __webpack_public_path__ + "static/media/fb.75640737.svg";